const config = {
  ENV: "production"
};
export default config;
